module.exports = __webpack_public_path__ + "img/quest_visualization_arrows_5.ff967419.svg";